// src/components/Footer.js
import React from "react";

const Footer = () => {
  return (
    <footer>
      &copy; 2025 Spandan Blood Centre. All rights reserved.
    </footer>
  );
};

export default Footer;
